import { PORTFOLIO_UPLOAD_LIMITS_MB } from "portfolio/constants/uploadLimits.constants";

/**
 * Central registry of file size limits (in MB) used throughout the project.
 *
 * Domain-specific limits are defined in the domain's own constants file and
 * re-exported here so consumers always import from a single shared location.
 *
 * Values are driven by VITE_ env vars; fallbacks mirror the values in
 * `.env.example`.
 */
export const UPLOAD_LIMITS_MB = {
  PORTFOLIO: PORTFOLIO_UPLOAD_LIMITS_MB,
  /**
   * Inline images in the rich-text editor are stored as base64 in the
   * description field, so the cap is intentionally low to protect database
   * row size — this is NOT an upload-to-disk limit.
   */
  EDITOR_INLINE_IMAGE: parseInt(
    import.meta.env.VITE_UPLOAD_MAX_EDITOR_INLINE_IMAGE_MB || "5",
    10,
  ),
};

export { PORTFOLIO_UPLOAD_LIMITS_MB };
